import { Card } from "../components/ui/card";
import { Info, Building2, FileText } from "lucide-react";
import { PRODUCT_NAME, PLATFORM_COMPANY_NAME } from "../lib/platformCompany";

// Mesmo em ambiente white-label, a tela Sobre precisa identificar
// corretamente o produto e a empresa responsável (Pacote 2, item 11) — por
// isso, diferente do resto da aplicação, esta página NUNCA usa a
// personalização do tenant (nome fantasia/logo/cores): sempre PRODUCT_NAME
// e PLATFORM_COMPANY_NAME, fixos.
const APP_VERSION = "2.0";

export default function Sobre() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold flex items-center gap-2"><Info size={28} className="text-blue-600" /> Sobre</h1>
        <p className="text-slate-500 text-sm">Informações da plataforma</p>
      </div>

      <Card className="p-6 space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center text-white font-heading font-black text-2xl" style={{ background: "linear-gradient(135deg, #3B82F6, #1D4ED8)" }}>L</div>
          <div>
            <div className="font-heading text-2xl font-black text-slate-900">{PRODUCT_NAME}</div>
            <div className="text-sm text-slate-500">Gestão de Serviços — versão {APP_VERSION}</div>
          </div>
        </div>

        <div className="pt-4 border-t border-slate-100 grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div className="flex items-start gap-2">
            <Building2 size={16} className="text-slate-400 mt-0.5" />
            <div>
              <div className="text-xs text-slate-500">Empresa responsável pelo produto</div>
              <div className="font-medium text-slate-900">{PLATFORM_COMPANY_NAME}</div>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <FileText size={16} className="text-slate-400 mt-0.5" />
            <div>
              <div className="text-xs text-slate-500">Sobre a plataforma</div>
              <div className="text-slate-700">Plataforma de gestão de fichas de serviço, aprovação, assinatura digital e faturamento, com suporte a múltiplas empresas (multiempresa).</div>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t border-slate-100 text-xs text-slate-400">
          Espaço reservado para termos de uso e informações legais em uma futura publicação.
        </div>
      </Card>
    </div>
  );
}
